module.exports = __webpack_public_path__ + "img/sound-off.c6258812.svg";